// extracted by mini-css-extract-plugin
export default {"title":"Notification_title__YoXsF"};